export const getStep = (num: number): number => {
  const zeros = getZeros(num);
  const step =
    Math.round(num / (2 * Math.pow(10, zeros))) * Math.pow(10, zeros - 1);
  return step;
};

export const getZeros = (num: number): number => {
  let zeros = -1;

  do {
    num = num / 10;
    ++zeros;
  } while (num > 1);
  return zeros;
};
interface RangeOptions {
  min: number;
  max: number;
  step?: number;
}

export const createRange = ({ min, max, step = 5 }: RangeOptions): number[] => {
  if (step <= 0) throw new Error("Step must be > 0");

  const result: number[] = [];
  const numSteps = Math.floor((max - min) / step) + 1;

  for (let i = 0; i < numSteps; i++) {
    const value = min + i * step;
    if (value <= max) {
      result.push(parseFloat(value.toFixed(12)));
    }
  }

  return result;
};
